import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Ng2ImgMaxService } from 'ng2-img-max';

import { ToasterService } from '../../_services/toaster.service';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthenicationService} from '../../_services/authenication.service';
import {PatientsService} from '../../_services/patients.service';
import {UserService} from '../../_services/user.service';
import {first} from 'rxjs/operators';
import {DynamicScriptLoaderServiceService} from '../../_services/dynamic-script-loader-service.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

declare var $: any;

@Component({
  selector: 'app-addpatient',
  templateUrl: './addpatient.component.html',
  styleUrls: ['./addpatient.component.css']
})
export class AddpatientComponent implements OnInit {

  addPatientForm: FormGroup;
  submitted = false;
  returnUrl: string;
  selectedfile: File = null;
  selectedfile1: File = null;
  userdetaild: string;
  dateob: string;
  imgtype = 'image/*';
  png = 'image/png';
  jpg = 'image/jpg';
  jpeg = 'image/jpeg';
  doc = 'application/msword';
  docx = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
  pdf = 'application/pdf';

  users: [];
  msgcode: string;

  // tslint:disable-next-line:max-line-length
  constructor(private formBuilder: FormBuilder, private router: Router, private route: ActivatedRoute, private toaster: ToasterService, private authenicationService: AuthenicationService, private userservice: UserService, private patientsService: PatientsService, private spinnerService: Ng4LoadingSpinnerService, private ng2ImgMax: Ng2ImgMaxService) { }

  ngOnInit() {

    // console.log(this.userdetaild = this.authenicationService.userDetails());
    this.userdetaild = this.authenicationService.userDetails();
    if (!this.userdetaild) {
      this.router.navigate(['/login']);
    }
    if (!this.userdetaild || this.userdetaild['users_usertype'] == 'employee2') {
      this.router.navigate(['/']);
    }
    // if (!this.userdetaild || this.userdetaild['users_usertype'] !== 'admin') {
    //   this.authenicationService.logout();
    //   this.router.navigateByUrl('/login');
    // }
    // DynamicScriptLoaderServiceService.adminScripts();
    // tslint:disable-next-line:max-line-length
    DynamicScriptLoaderServiceService.loadDynamicScript('https://cdnjs.cloudflare.com/ajax/libs/bootstrap-datepicker/1.9.0/js/bootstrap-datepicker.min.js');

    this.addPatientForm = this.formBuilder.group({
      users_name: ['', [Validators.required, Validators.minLength(3)]],
      users_email: ['', [Validators.required, Validators.email]],
      users_password: ['', [Validators.required, Validators.minLength(6)]],
      users_mobile: ['', [Validators.required]],
      users_status: ['true', [Validators.required]],
    });

    this.returnUrl = this.route.snapshot.queryParams.returnUrl || '/';
    const self = this;
    $('.datepicker').datepicker({
      format: 'mm-dd-yyyy',
      todayHighlight: true,
      // tslint:disable-next-line:only-arrow-functions
    }).on('changeDate', function(e) {
      self.onchangedate(e.format());
    });
  }

  get f() { return this.addPatientForm.controls; }

  fileUpload(event) {
    let image = event.target.files[0];
    if (image.type === this.jpg || image.type === this.png || image.type === this.jpeg) {
      //this.addDocForm.controls['photo'].setValue(this.selectedfile ? this.selectedfile : '');

      this.ng2ImgMax.compressImage(image, 1, true).subscribe(
        result => {
          this.selectedfile = result;
        },
        error => {
          console.log(JSON.stringify(error));
          this.toaster.showError('😢 Oh no!', error);
        }
      );
    } else {
      this.addPatientForm.controls.photo.reset();
      this.toaster.showError('File Type', 'Only Images are allowed');
      return false;
    }
  }

  fileUpload1(event) {
    this.selectedfile1 = event.target.files[0];
    if (this.selectedfile1.type === this.doc || this.selectedfile1.type === this.docx || this.selectedfile1.type === this.pdf) {
      return true;
    } else {
      this.addPatientForm.controls.certificates.reset();
      this.toaster.showError('File Type', 'Only PDF/Documents are allowed');
      return false;
    }
  }

  onchangedate(dobdate) {
    this.addPatientForm.controls.dob.setErrors(null);
    this.addPatientForm.controls.dob.setValue(dobdate);
  }

  onSubmit() {
    this.submitted = true;
    this.spinnerService.show();
    // stop here if form is invalid
    if (this.addPatientForm.invalid) {
      this.spinnerService.hide();
      return;
    }

    const addUserPayload = {
      users_name: this.addPatientForm.controls.users_name.value,
      users_email: this.addPatientForm.controls.users_email.value,
      users_mobile: this.addPatientForm.controls.users_mobile.value,
      users_code: '+91',
      users_city: 'N/A',
      users_password: this.addPatientForm.controls.users_password.value,
      users_status: this.addPatientForm.controls.users_status.value,
      users_usertype: 'patient'
    };

    const addDoctorPayload = {
      blood_group: 'N/A',
      dob: 'N/A',
      address: 'N/A',
      language: 'N/A',
      problems: 'N/A',
      marital_status: 'N/A',
      gender: 'N/A',
      profession: 'N/A',
      message: 'N/A',
    };

    const formdata = new FormData();

    formdata.append('users_name', addUserPayload.users_name);
    formdata.append('users_email', addUserPayload.users_email);
    formdata.append('users_code', addUserPayload.users_code);
    formdata.append('users_mobile', addUserPayload.users_mobile);
    formdata.append('users_city', addUserPayload.users_city);
    formdata.append('users_password', addUserPayload.users_password);
    formdata.append('users_status', addUserPayload.users_status);
    formdata.append('users_usertype', addUserPayload.users_usertype);
    // formdata.append('photo', this.selectedfile);



    this.addUser(formdata, addDoctorPayload, this.selectedfile1);

  }

  addUser(payload, payload1, certificatefile) {
    this.userservice.addUser(payload)
      .pipe(first())
      .subscribe(
        (data: any) => {
          if (data && data.ResponseCode === '200') {

            const formdata = new FormData();
            formdata.append('patientid', data.UserData._id);
            formdata.append('blood_group', payload1.blood_group);
            formdata.append('dob', payload1.dob);
            formdata.append('address', payload1.address);
            formdata.append('language', payload1.language);
            formdata.append('problems', payload1.problems);
            formdata.append('marital_status', payload1.marital_status);
            formdata.append('gender', payload1.gender);
            formdata.append('profession', payload1.profession);
            // if (this.selectedfile1) {
            //   formdata.append('reports', certificatefile);
            // }
            formdata.append('message', payload1.message);

            this.addPatient(formdata);

          } else {
            this.toaster.showError('Add Patient', data.ResponseMessage);
            this.msgcode = data.ResponseCode;
          }
          // this.router.navigate([this.returnUrl]);
        },
        error => {
          this.toaster.showError('Add Patient', error.error.ResponseMessage);
          this.msgcode = error.error.ResponseCode;
        });
  }

  addPatient(payload) {
    this.patientsService.addPatient(payload)
      .pipe(first())
      .subscribe(
        (data: any) => {
          if (data && data.ResponseCode === '200') {
            //this.toaster.showSuccess('Add Patient', data.ResponseMessage);
            this.router.navigate(['/patientslist']);
          } else {
            this.toaster.showError('Add Patient', data.ResponseMessage);
          }
          // this.router.navigate([this.returnUrl]);
        },
        error => {
          this.toaster.showError('Add Patient', error.error.ResponseMessage);
        });
  }


}
